import React from "react";
import { Row, Col, Label, Input, Button } from "reactstrap";

// Campos opcionales del cliente (los que vienen de SAE) + lista de contactos.
// Lo usan el alta (ClientesCreate) y la edicion (ListadoClientes) con el mismo estado.

export const PUESTOS_CONTACTO = ["Compras", "Pagos", "Almacén", "Calidad", "Dueño"];

export const EXTRA_CLIENTE_VACIO = {
  claveSAE: "",
  telefono2: "",
  limiteCredito: 0,
  cuentaContable: "",
  direccionEnvio: "",
  contactos: [],
};

// Toma los campos opcionales de un cliente que viene de la API.
export const extraDeCliente = (c) => ({
  claveSAE: c.claveSAE || "",
  telefono2: c.telefono2 || "",
  limiteCredito: c.limiteCredito || 0,
  cuentaContable: c.cuentaContable || "",
  direccionEnvio: c.direccionEnvio || "",
  contactos: (c.contactos || []).map((k) => ({
    nombre: k.nombre || "",
    puesto: k.puesto || "",
    telefono: k.telefono || "",
    email: k.email || "",
    notas: k.notas || "",
  })),
});

// Lo que se manda al back (sin contactos vacios).
export const extraParaGuardar = (extra) => ({
  ...extra,
  limiteCredito: Number(extra.limiteCredito) || 0,
  contactos: contactosParaGuardar(extra.contactos),
});

// Lista editable de contactos (nombre, puesto, telefono, email, notas). La usan el cliente y
// sus sucursales.
export function ContactosEditor({ contactos = [], onChange, titulo = "Contactos" }) {
  const setContacto = (i, campo, valor) =>
    onChange(contactos.map((k, j) => (j === i ? { ...k, [campo]: valor } : k)));
  const agrega = () => onChange([...contactos, { nombre: "", puesto: "", telefono: "", email: "", notas: "" }]);
  const quita = (i) => onChange(contactos.filter((_, j) => j !== i));

  return (
    <>
      <Label>{titulo}</Label>
      {contactos.length === 0 && (
        <div>
          <small className="text-muted">Sin contactos capturados.</small>
        </div>
      )}
      {contactos.map((k, i) => (
        <Row key={i} className="align-items-center" style={{ marginBottom: 6 }}>
          <Col md={3}>
            <Input bsSize="sm" placeholder="Nombre" value={k.nombre || ""} onChange={(e) => setContacto(i, "nombre", e.target.value)} />
          </Col>
          <Col md={2}>
            <Input bsSize="sm" type="select" value={k.puesto || ""} onChange={(e) => setContacto(i, "puesto", e.target.value)}>
              <option value="">Puesto...</option>
              {PUESTOS_CONTACTO.map((p) => (
                <option key={p} value={p}>{p}</option>
              ))}
            </Input>
          </Col>
          <Col md={2}>
            <Input bsSize="sm" placeholder="Teléfono" value={k.telefono || ""} onChange={(e) => setContacto(i, "telefono", e.target.value)} />
          </Col>
          <Col md={2}>
            <Input bsSize="sm" placeholder="Email" value={k.email || ""} onChange={(e) => setContacto(i, "email", e.target.value)} />
          </Col>
          <Col md={2}>
            <Input bsSize="sm" placeholder="Notas (ext, horario...)" value={k.notas || ""} onChange={(e) => setContacto(i, "notas", e.target.value)} />
          </Col>
          <Col md={1}>
            <Button size="sm" color="danger" onClick={() => quita(i)} title="Quitar contacto">
              <i className="fas fa-minus"></i>
            </Button>
          </Col>
        </Row>
      ))}
      <Button size="sm" color="info" onClick={agrega}>
        <i className="fas fa-plus" style={{ marginRight: 6 }} /> Agregar contacto
      </Button>
    </>
  );
}

// Lo que se guarda (sin contactos vacios).
export const contactosParaGuardar = (contactos) =>
  (contactos || []).filter((k) => k.nombre || k.telefono || k.email);

function DatosAdicionalesCliente({ extra, setExtra }) {
  const set = (campo, valor) => setExtra((prev) => ({ ...prev, [campo]: valor }));

  return (
    <>
      <Row>
        <Col md={2}>
          <Label>Clave SAE</Label>
          <Input type="text" value={extra.claveSAE} onChange={(e) => set("claveSAE", e.target.value)} />
        </Col>
        <Col md={2}>
          <Label>Teléfono 2</Label>
          <Input type="text" value={extra.telefono2} onChange={(e) => set("telefono2", e.target.value)} />
        </Col>
        <Col md={2}>
          <Label>Límite de crédito</Label>
          <Input
            type="number"
            min={0}
            value={extra.limiteCredito}
            onChange={(e) => set("limiteCredito", e.target.value)}
          />
        </Col>
        <Col md={2}>
          <Label>Cuenta contable</Label>
          <Input type="text" value={extra.cuentaContable} onChange={(e) => set("cuentaContable", e.target.value)} />
        </Col>
        <Col md={4}>
          <Label>Dirección de envío</Label>
          <Input
            type="text"
            placeholder="Si es distinta a la dirección fiscal"
            value={extra.direccionEnvio}
            onChange={(e) => set("direccionEnvio", e.target.value)}
          />
        </Col>
      </Row>
      <br />
      <ContactosEditor contactos={extra.contactos} onChange={(c) => set("contactos", c)} />
    </>
  );
}

export default DatosAdicionalesCliente;
